define(
    'utils/is-in-view',['jquery'], 

    function ($) {

        /**
         * Checks if provided element is in view
         * @param  {HtmlElement} el - The element to check
         * @param  {Number} ox - offset x in pixels in relation to the viewport - default is 0
         * @param  {Number} oy - offset y in pixels - default is 0
         * @param  {Number} x  - Determines how much of the element needs to be visible - default is 1 (the full element)
         * @param  {Number} y  - Determines how much of the element needs to be visible - default is 1 (the full element)
         * 
         * @return {Boolean} true if the element is determined visible. 
         */
        return function(el, ox, oy, x, y){
            ox = ox || 0;
            oy = oy || 0;
            x = x || 1;
            y = y || 1;

            var win = $(window);

            var viewport = {
                top : win.scrollTop(),
                left : win.scrollLeft()
            };

            viewport.right = win.scrollLeft() + ox + win.width();
            viewport.bottom = win.scrollTop() + oy + win.height();

            var height = el.outerHeight();
            var width = el.outerWidth();

            if(!width || !height){
                return false;
            }

            var bounds = el.offset();
            bounds.right = bounds.left + width;
            bounds.bottom = bounds.top + height;

            var visible = (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));

            if(!visible){
                return false;
            }

            var deltas = {
                top : Math.min( 1, ( bounds.bottom - viewport.top ) / height),
                bottom : Math.min(1, ( viewport.bottom - bounds.top ) / height),
                left : Math.min(1, ( bounds.right - viewport.left ) / width),
                right : Math.min(1, ( viewport.right - bounds.left ) / width)
            };

            return (deltas.left * deltas.right) >= x && (deltas.top * deltas.bottom) >= y;
        };
    }
);
